<template>
  <div class="sp-date-field-actions">
    <sp-button color="secondary" data-action="apply" @click="emit('apply')">{{ t("date_apply") }}</sp-button>
    <sp-button color="secondary" data-action="clear" @click="emit('clear')">{{ t("date_clear") }}</sp-button>
    <sp-button color="secondary" data-action="cancel" @click="emit('cancel')">{{ t("date_cancel") }}</sp-button>
  </div>
</template>

<script setup>
import { t } from "#ce/shared/forms-i18n";

const emit = defineEmits(["apply", "clear", "cancel"]);
</script>

<style lang="scss">
:host {
  --date-field-host-action-min-width: var(--sp-comp-button-min-width);
  --date-field-host-action-bg-color: var(--sp-comp-button-secondary-bg-color);
  --date-field-host-action-font-weight: var(--sp-comp-button-font-weight);
}

.sp-date-field-actions sp-button {
  --sp-comp-button-min-width: var(--sp-comp-date-field-action-min-width, var(--date-field-host-action-min-width));
  --sp-comp-button-secondary-bg-color: var(
    --sp-comp-date-field-action-bg-color,
    var(--date-field-host-action-bg-color)
  );
  --sp-comp-button-font-weight: var(--sp-comp-date-field-action-font-weight, var(--date-field-host-action-font-weight));
}

.sp-date-field-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--sp-comp-date-field-actions-gap, var(--sp-ref-scale-8));
  margin-top: var(--sp-comp-date-field-actions-margin-top, var(--sp-ref-scale-16));
}
</style>
